// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.graph-view {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: #1a1a1a;
  overflow: hidden;
  position: relative;
}

/* Fullscreen centered mode */
.graph-section.fullscreen-centered .graph-view {
  max-width: 1400px;
  margin: 0 auto;
  width: 100%;
}

.graph-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 24px;
  background: #2d2d2d;
  border-bottom: 1px solid #404040;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.graph-header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.graph-header-left h1 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #e0e0e0;
}

.back-button,
.refresh-button {
  padding: 8px 16px;
  border: 1px solid #555;
  border-radius: 4px;
  background: #3a3a3a;
  color: #e0e0e0;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s;
}

.back-button:hover,
.refresh-button:hover {
  background: #4a4a4a;
  border-color: #666;
  color: #fff;
}

.graph-header-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.session-info {
  font-size: 12px;
  color: #999;
  font-family: monospace;
}

.graph-content {
  flex: 1 1;
  display: flex;
  overflow: hidden;
}

.graph-main {
  flex: 1 1;
  position: relative;
  overflow: auto;
  background: #1a1a1a;
}

.graph-sidebar {
  width: 35%;
  background: #2d2d2d;
  border-left: 1px solid #404040;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.sidebar-section {
  padding: 16px;
  border-bottom: 1px solid #404040;
}

.sidebar-section h3 {
  margin: 0 0 12px 0;
  font-size: 16px;
  font-weight: 600;
  color: #e0e0e0;
}

.node-details {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.detail-item {
  font-size: 14px;
  color: #b0b0b0;
}

.detail-item strong {
  color: #e0e0e0;
  margin-right: 8px;
}

.message-preview {
  margin-top: 4px;
  padding: 8px;
  background: #3a3a3a;
  border-radius: 4px;
  font-size: 12px;
  color: #b0b0b0;
  word-break: break-word;
}

.no-selection,
.no-messages {
  color: #888;
  font-size: 14px;
  font-style: italic;
}

.message-history {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 100%;
  overflow-y: auto;
}

.message-item {
  padding: 12px;
  background: #3a3a3a;
  border-radius: 4px;
  border-left: 3px solid #4A90E2;
}

.message-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  font-size: 12px;
}

.message-route {
  font-weight: 600;
  color: #4A90E2;
}

.user-agent{
  color: rgb(80, 200, 120) !important;
}

.flight-mcp-active{
  border-color: rgb(255, 107, 107) !important;
  background: linear-gradient(135deg, #E8F4FD 0%, #F0F8FF 50%, #FFFFFF 100%)  !important;
  box-shadow: 
    0 0 0 6px rgba(255, 107, 107, 0.4),
    0 0 20px rgba(255, 107, 107, 0.6),
    0 4px 16px rgba(255, 107, 107, 0.3)  !important;
}


.flight-mcp{
   color: rgb(255, 107, 107) !important;
}

.hotel-mcp-active{
  border-color: rgb(255, 165, 0) !important;
  background: linear-gradient(135deg, #E8F4FD 0%, #F0F8FF 50%, #FFFFFF 100%)  !important;
  box-shadow: 
    0 0 0 6px rgba(255, 165, 0, 0.4),
    0 0 20px rgba(255, 165, 0, 0.6),
    0 4px 16px rgba(255, 165, 0 , 0.3)  !important;
}


.hotel-mcp{
   color: rgb(255, 165, 0) !important;
}


.merchant-agent-active{
  border-color: rgb(155, 89, 182) !important;
  background: linear-gradient(135deg, #E8F4FD 0%, #F0F8FF 50%, #FFFFFF 100%);
  box-shadow: 
    0 0 0 6px rgba(155, 89, 182, 0.4),
    0 0 20px rgba(155, 89, 182, 0.6),
    0 4px 16px rgba(155, 89, 182 , 0.3)!important;
}


.merchant-agent{
  color:rgb(155, 89, 182) !important;
}

.acquirer-active{
  border-color: rgb(149, 165, 166)  !important;
  background: linear-gradient(135deg, #E8F4FD 0%, #F0F8FF 50%, #FFFFFF 100%)  !important;
  box-shadow: 
    0 0 0 6px rgba(149, 165, 166, 0.4),
    0 0 20px rgba(149, 165, 166, 0.6),
    0 4px 16px rgba(149, 165, 166 , 0.3) !important;
}

.acquirer{
  color:rgb(149, 165, 166) !important;
}

.payment-processor-active{
  border-color: rgb(231, 76, 60) !important;
  background: linear-gradient(135deg, #E8F4FD 0%, #F0F8FF 50%, #FFFFFF 100%)  !important;
  box-shadow: 
    0 0 0 6px rgba(231, 76, 60, 0.4),
    0 0 20px rgba(231, 76, 60, 0.6),
    0 4px 16px rgba(231, 76, 60 , 0.3) !important;
}

.payment-processor{
  color:rgb(231, 76, 60) !important;
}

.issuer-active{
  border-color: rgb(149, 165, 166)!important;
  background: linear-gradient(135deg, #E8F4FD 0%, #F0F8FF 50%, #FFFFFF 100%) !important;
  box-shadow: 
    0 0 0 6px rgba(149, 165, 166, 0.4),
    0 0 20px rgba(149, 165, 166, 0.6),
    0 4px 16px rgba(149, 165, 166 , 0.3) !important;
}
  

.issuer{
  color:rgb(149, 165, 166) !important;
}
.message-time {
  color: #888;
  font-size: 11px;
  margin-top: 6px;
  text-align: right;
  font-family: monospace;
}

.message-content {
  font-size: 12px;
  color: #fffafa;
  word-break: break-word;
  margin-bottom: 4px;
}

/* Node Logs Styles */
.loading-logs,
.no-logs {
  color: #888;
  font-size: 14px;
  font-style: italic;
  text-align: center;
  padding: 16px;
}

.log-tabs {
  display: flex;
  gap: 4px;
  margin-bottom: 12px;
  border-bottom: 1px solid #404040;
}

.log-tab {
  flex: 1 1;
  padding: 8px 12px;
  background: transparent;
  border: none;
  border-bottom: 2px solid transparent;
  color: #888;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  text-align: center;
}

.log-tab:hover {
  color: #b0b0b0;
  background: rgba(74, 144, 226, 0.1);
}

.log-tab.active {
  color: #4A90E2;
  border-bottom-color: #4A90E2;
  background: rgba(74, 144, 226, 0.1);
}

.node-logs {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 500px;
  overflow-y: auto;
}

.log-entry {
  padding: 12px;
  background: #3a3a3a;
  border-radius: 4px;
  border-left: 3px solid #4A90E2;
  font-size: 12px;
  color: #b0b0b0;
}

.log-entry.log-processing {
  border-left-color: #4A90E2;
  background: linear-gradient(90deg, rgba(74, 144, 226, 0.2) 0%, #3a3a3a 10%);
  animation: logPulse 2s ease-in-out infinite;
}

@keyframes logPulse {
  0%, 100% {
    background: linear-gradient(90deg, rgba(74, 144, 226, 0.2) 0%, #3a3a3a 10%);
  }
  50% {
    background: linear-gradient(90deg, rgba(74, 144, 226, 0.3) 0%, #3a3a3a 10%);
  }
}

.log-node-processing {
  color: #4A90E2;
  font-weight: 600;
  font-size: 11px;
  margin-top: 4px;
}

.log-status {
  font-size: 11px;
  color: #888;
  margin-top: 4px;
}

.log-status strong {
  color: #4A90E2;
  text-transform: uppercase;
}

.log-status .log-time {
  color: #888;
  font-size: 11px;
  margin-left: auto;
}

.log-data-details {
  margin-top: 8px;
}

.log-data-details summary {
  cursor: pointer;
  color: #4A90E2;
  font-size: 11px;
  -webkit-user-select: none;
          user-select: none;
  font-weight: 600;
}

.log-data-details summary:hover {
  text-decoration: underline;
}

.data-details {
  margin-top: 8px;
}

.data-details summary {
  cursor: pointer;
  color: #4A90E2;
  font-size: 12px;
  -webkit-user-select: none;
          user-select: none;
}

.data-details summary:hover {
  text-decoration: underline;
}

.data-json {
  margin-top: 8px;
  padding: 8px;
  background: #1a1a1a;
  border-radius: 4px;
  font-size: 10px;
  overflow-x: auto;
  max-height: 200px;
  overflow-y: auto;
  font-family: 'Courier New', monospace;
  color: #b0b0b0;
  line-height: 1.4;
  border: 1px solid #404040;
}

.log-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  font-weight: 600;
}

.log-type {
  color: #4A90E2;
  text-transform: uppercase;
  font-size: 11px;
}

.log-time {
  color: #888;
  font-size: 11px;
}

.log-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.log-message,
.log-content-text {
  color: white;
  font-weight: bold;
  word-break: break-word;
  line-height: 1.4;
}

.log-route {
  color: #888;
  font-size: 11px;
  font-style: italic;
}

.log-details {
  margin-top: 8px;
}

.log-details summary {
  cursor: pointer;
  color: #4A90E2;
  font-size: 11px;
  -webkit-user-select: none;
          user-select: none;
}

.log-details summary:hover {
  text-decoration: underline;
}

.log-json {
  margin-top: 8px;
  padding: 8px;
  background: #1a1a1a;
  border-radius: 4px;
  font-size: 10px;
  overflow-x: auto;
  max-height: 200px;
  overflow-y: auto;
  font-family: 'Courier New', monospace;
  color: #b0b0b0;
  line-height: 1.4;
  border: 1px solid #404040;
}

.graph-loading,
.graph-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  gap: 16px;
  color: #e0e0e0;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #3a3a3a;
  border-top: 4px solid #4A90E2;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.graph-error button {
  padding: 8px 16px;
  border: 1px solid #555;
  border-radius: 4px;
  background: #3a3a3a;
  color: #e0e0e0;
  cursor: pointer;
  font-size: 14px;
}

.graph-error button:hover {
  background: #4a4a4a;
  border-color: #666;
  color: #fff;
}

`, "",{"version":3,"sources":["webpack://./src/graph_components/GraphView.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,6BAA6B;AAC7B;EACE,iBAAiB;EACjB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,2CAA2C;EAC3C,sFAAsF;EACtF;;;mDAGiD;AACnD;;;AAGA;GACG,oCAAoC;AACvC;;AAEA;EACE,yCAAyC;EACzC,sFAAsF;EACtF;;;kDAGgD;AAClD;;;AAGA;GACG,kCAAkC;AACrC;;;AAGA;EACE,0CAA0C;EAC1C,0EAA0E;EAC1E;;;iDAG+C;AACjD;;;AAGA;EACE,kCAAkC;AACpC;;AAEA;EACE,4CAA4C;EAC5C,sFAAsF;EACtF;;;mDAGiD;AACnD;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,yCAAyC;EACzC,sFAAsF;EACtF;;;iDAG+C;AACjD;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,0CAA0C;EAC1C,qFAAqF;EACrF;;;mDAGiD;AACnD;;;AAGA;EACE,mCAAmC;AACrC;AACA;EACE,WAAW;EACX,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;;EAEE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,oCAAoC;EACpC,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,2EAA2E;EAC3E,2CAA2C;AAC7C;;AAEA;EACE;IACE,2EAA2E;EAC7E;EACA;IACE,2EAA2E;EAC7E;AACF;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,qCAAqC;EACrC,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;EAEE,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,qCAAqC;EACrC,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb","sourcesContent":[".graph-view {\n  width: 100%;\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  background: #1a1a1a;\n  overflow: hidden;\n  position: relative;\n}\n\n/* Fullscreen centered mode */\n.graph-section.fullscreen-centered .graph-view {\n  max-width: 1400px;\n  margin: 0 auto;\n  width: 100%;\n}\n\n.graph-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 24px;\n  background: #2d2d2d;\n  border-bottom: 1px solid #404040;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.graph-header-left {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.graph-header-left h1 {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 600;\n  color: #e0e0e0;\n}\n\n.back-button,\n.refresh-button {\n  padding: 8px 16px;\n  border: 1px solid #555;\n  border-radius: 4px;\n  background: #3a3a3a;\n  color: #e0e0e0;\n  cursor: pointer;\n  font-size: 14px;\n  transition: all 0.2s;\n}\n\n.back-button:hover,\n.refresh-button:hover {\n  background: #4a4a4a;\n  border-color: #666;\n  color: #fff;\n}\n\n.graph-header-right {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.session-info {\n  font-size: 12px;\n  color: #999;\n  font-family: monospace;\n}\n\n.graph-content {\n  flex: 1;\n  display: flex;\n  overflow: hidden;\n}\n\n.graph-main {\n  flex: 1;\n  position: relative;\n  overflow: auto;\n  background: #1a1a1a;\n}\n\n.graph-sidebar {\n  width: 35%;\n  background: #2d2d2d;\n  border-left: 1px solid #404040;\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n}\n\n.sidebar-section {\n  padding: 16px;\n  border-bottom: 1px solid #404040;\n}\n\n.sidebar-section h3 {\n  margin: 0 0 12px 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: #e0e0e0;\n}\n\n.node-details {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.detail-item {\n  font-size: 14px;\n  color: #b0b0b0;\n}\n\n.detail-item strong {\n  color: #e0e0e0;\n  margin-right: 8px;\n}\n\n.message-preview {\n  margin-top: 4px;\n  padding: 8px;\n  background: #3a3a3a;\n  border-radius: 4px;\n  font-size: 12px;\n  color: #b0b0b0;\n  word-break: break-word;\n}\n\n.no-selection,\n.no-messages {\n  color: #888;\n  font-size: 14px;\n  font-style: italic;\n}\n\n.message-history {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  max-height: 100%;\n  overflow-y: auto;\n}\n\n.message-item {\n  padding: 12px;\n  background: #3a3a3a;\n  border-radius: 4px;\n  border-left: 3px solid #4A90E2;\n}\n\n.message-header {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 8px;\n  font-size: 12px;\n}\n\n.message-route {\n  font-weight: 600;\n  color: #4A90E2;\n}\n\n.user-agent{\n  color: rgb(80, 200, 120) !important;\n}\n\n.flight-mcp-active{\n  border-color: rgb(255, 107, 107) !important;\n  background: linear-gradient(135deg, #E8F4FD 0%, #F0F8FF 50%, #FFFFFF 100%)  !important;\n  box-shadow: \n    0 0 0 6px rgba(255, 107, 107, 0.4),\n    0 0 20px rgba(255, 107, 107, 0.6),\n    0 4px 16px rgba(255, 107, 107, 0.3)  !important;\n}\n\n\n.flight-mcp{\n   color: rgb(255, 107, 107) !important;\n}\n\n.hotel-mcp-active{\n  border-color: rgb(255, 165, 0) !important;\n  background: linear-gradient(135deg, #E8F4FD 0%, #F0F8FF 50%, #FFFFFF 100%)  !important;\n  box-shadow: \n    0 0 0 6px rgba(255, 165, 0, 0.4),\n    0 0 20px rgba(255, 165, 0, 0.6),\n    0 4px 16px rgba(255, 165, 0 , 0.3)  !important;\n}\n\n\n.hotel-mcp{\n   color: rgb(255, 165, 0) !important;\n}\n\n\n.merchant-agent-active{\n  border-color: rgb(155, 89, 182) !important;\n  background: linear-gradient(135deg, #E8F4FD 0%, #F0F8FF 50%, #FFFFFF 100%);\n  box-shadow: \n    0 0 0 6px rgba(155, 89, 182, 0.4),\n    0 0 20px rgba(155, 89, 182, 0.6),\n    0 4px 16px rgba(155, 89, 182 , 0.3)!important;\n}\n\n\n.merchant-agent{\n  color:rgb(155, 89, 182) !important;\n}\n\n.acquirer-active{\n  border-color: rgb(149, 165, 166)  !important;\n  background: linear-gradient(135deg, #E8F4FD 0%, #F0F8FF 50%, #FFFFFF 100%)  !important;\n  box-shadow: \n    0 0 0 6px rgba(149, 165, 166, 0.4),\n    0 0 20px rgba(149, 165, 166, 0.6),\n    0 4px 16px rgba(149, 165, 166 , 0.3) !important;\n}\n\n.acquirer{\n  color:rgb(149, 165, 166) !important;\n}\n\n.payment-processor-active{\n  border-color: rgb(231, 76, 60) !important;\n  background: linear-gradient(135deg, #E8F4FD 0%, #F0F8FF 50%, #FFFFFF 100%)  !important;\n  box-shadow: \n    0 0 0 6px rgba(231, 76, 60, 0.4),\n    0 0 20px rgba(231, 76, 60, 0.6),\n    0 4px 16px rgba(231, 76, 60 , 0.3) !important;\n}\n\n.payment-processor{\n  color:rgb(231, 76, 60) !important;\n}\n\n.issuer-active{\n  border-color: rgb(149, 165, 166)!important;\n  background: linear-gradient(135deg, #E8F4FD 0%, #F0F8FF 50%, #FFFFFF 100%) !important;\n  box-shadow: \n    0 0 0 6px rgba(149, 165, 166, 0.4),\n    0 0 20px rgba(149, 165, 166, 0.6),\n    0 4px 16px rgba(149, 165, 166 , 0.3) !important;\n}\n  \n\n.issuer{\n  color:rgb(149, 165, 166) !important;\n}\n.message-time {\n  color: #888;\n  font-size: 11px;\n  margin-top: 6px;\n  text-align: right;\n  font-family: monospace;\n}\n\n.message-content {\n  font-size: 12px;\n  color: #fffafa;\n  word-break: break-word;\n  margin-bottom: 4px;\n}\n\n/* Node Logs Styles */\n.loading-logs,\n.no-logs {\n  color: #888;\n  font-size: 14px;\n  font-style: italic;\n  text-align: center;\n  padding: 16px;\n}\n\n.log-tabs {\n  display: flex;\n  gap: 4px;\n  margin-bottom: 12px;\n  border-bottom: 1px solid #404040;\n}\n\n.log-tab {\n  flex: 1;\n  padding: 8px 12px;\n  background: transparent;\n  border: none;\n  border-bottom: 2px solid transparent;\n  color: #888;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  text-align: center;\n}\n\n.log-tab:hover {\n  color: #b0b0b0;\n  background: rgba(74, 144, 226, 0.1);\n}\n\n.log-tab.active {\n  color: #4A90E2;\n  border-bottom-color: #4A90E2;\n  background: rgba(74, 144, 226, 0.1);\n}\n\n.node-logs {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  max-height: 500px;\n  overflow-y: auto;\n}\n\n.log-entry {\n  padding: 12px;\n  background: #3a3a3a;\n  border-radius: 4px;\n  border-left: 3px solid #4A90E2;\n  font-size: 12px;\n  color: #b0b0b0;\n}\n\n.log-entry.log-processing {\n  border-left-color: #4A90E2;\n  background: linear-gradient(90deg, rgba(74, 144, 226, 0.2) 0%, #3a3a3a 10%);\n  animation: logPulse 2s ease-in-out infinite;\n}\n\n@keyframes logPulse {\n  0%, 100% {\n    background: linear-gradient(90deg, rgba(74, 144, 226, 0.2) 0%, #3a3a3a 10%);\n  }\n  50% {\n    background: linear-gradient(90deg, rgba(74, 144, 226, 0.3) 0%, #3a3a3a 10%);\n  }\n}\n\n.log-node-processing {\n  color: #4A90E2;\n  font-weight: 600;\n  font-size: 11px;\n  margin-top: 4px;\n}\n\n.log-status {\n  font-size: 11px;\n  color: #888;\n  margin-top: 4px;\n}\n\n.log-status strong {\n  color: #4A90E2;\n  text-transform: uppercase;\n}\n\n.log-status .log-time {\n  color: #888;\n  font-size: 11px;\n  margin-left: auto;\n}\n\n.log-data-details {\n  margin-top: 8px;\n}\n\n.log-data-details summary {\n  cursor: pointer;\n  color: #4A90E2;\n  font-size: 11px;\n  user-select: none;\n  font-weight: 600;\n}\n\n.log-data-details summary:hover {\n  text-decoration: underline;\n}\n\n.data-details {\n  margin-top: 8px;\n}\n\n.data-details summary {\n  cursor: pointer;\n  color: #4A90E2;\n  font-size: 12px;\n  user-select: none;\n}\n\n.data-details summary:hover {\n  text-decoration: underline;\n}\n\n.data-json {\n  margin-top: 8px;\n  padding: 8px;\n  background: #1a1a1a;\n  border-radius: 4px;\n  font-size: 10px;\n  overflow-x: auto;\n  max-height: 200px;\n  overflow-y: auto;\n  font-family: 'Courier New', monospace;\n  color: #b0b0b0;\n  line-height: 1.4;\n  border: 1px solid #404040;\n}\n\n.log-header {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 8px;\n  font-weight: 600;\n}\n\n.log-type {\n  color: #4A90E2;\n  text-transform: uppercase;\n  font-size: 11px;\n}\n\n.log-time {\n  color: #888;\n  font-size: 11px;\n}\n\n.log-content {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.log-message,\n.log-content-text {\n  color: white;\n  font-weight: bold;\n  word-break: break-word;\n  line-height: 1.4;\n}\n\n.log-route {\n  color: #888;\n  font-size: 11px;\n  font-style: italic;\n}\n\n.log-details {\n  margin-top: 8px;\n}\n\n.log-details summary {\n  cursor: pointer;\n  color: #4A90E2;\n  font-size: 11px;\n  user-select: none;\n}\n\n.log-details summary:hover {\n  text-decoration: underline;\n}\n\n.log-json {\n  margin-top: 8px;\n  padding: 8px;\n  background: #1a1a1a;\n  border-radius: 4px;\n  font-size: 10px;\n  overflow-x: auto;\n  max-height: 200px;\n  overflow-y: auto;\n  font-family: 'Courier New', monospace;\n  color: #b0b0b0;\n  line-height: 1.4;\n  border: 1px solid #404040;\n}\n\n.graph-loading,\n.graph-error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n  gap: 16px;\n  color: #e0e0e0;\n}\n\n.loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #3a3a3a;\n  border-top: 4px solid #4A90E2;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.graph-error button {\n  padding: 8px 16px;\n  border: 1px solid #555;\n  border-radius: 4px;\n  background: #3a3a3a;\n  color: #e0e0e0;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.graph-error button:hover {\n  background: #4a4a4a;\n  border-color: #666;\n  color: #fff;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
